import { ClientEndpointType } from "@app/shared/src/models/Shared.Models.Api.V1.ClientEndpoints.ClientEndpointType.gen";

/**
 * User-facing name for each integration type.
 *
 * Deliberately not the generated `ClientEndpointTypeDisplayNames`, which is derived from the C# enum
 * member names and so reads as "NTCIP_DMS" and gives no hint that Luxcom means SDLC or that WebRelay is a
 * closure. These are the names the endpoint editor's type picker has always shown; they live here so the
 * picker and the endpoint table can't drift into calling the same integration two different things.
 */
export const CLIENT_ENDPOINT_TYPE_LABELS: Record<ClientEndpointType, string> = {
    [ClientEndpointType.WebRelay]: "Closure (WebRelay)",
    [ClientEndpointType.Email]: "Email",
    [ClientEndpointType.Json]: "Json",
    [ClientEndpointType.NTCIP_DMS]: "NTCIP DMS",
    [ClientEndpointType.Luxcom]: "SDLC (Luxcom)",
    [ClientEndpointType.MS2]: "MS2",
    [ClientEndpointType.Drakewell]: "Drakewell",
    [ClientEndpointType.Fabric]: "Microsoft Fabric Event Stream",
};

/** Label for a type, or "" when absent — table cells render the empty string rather than "undefined". */
export const clientEndpointTypeLabel = (type: ClientEndpointType | undefined): string =>
    type != null ? CLIENT_ENDPOINT_TYPE_LABELS[type] ?? "" : "";

/**
 * Type options for a picker or a select filter, ordered by the label the user reads rather than by the
 * enum's numeric order — which is arbitrary to anyone who can't see the underlying values.
 */
export const clientEndpointTypeOptions = (): { value: string; label: string }[] =>
    (Object.keys(CLIENT_ENDPOINT_TYPE_LABELS) as unknown as ClientEndpointType[])
        .map((t) => ({ value: `${t}`, label: CLIENT_ENDPOINT_TYPE_LABELS[t] }))
        .sort((a, b) => a.label.localeCompare(b.label));
